import payrollTableGroupedComponentUrl from './payrollTableGroupedComponent.html';

export default {
  bindings: {
    data: '<',
    totals: '<',
    columns: '<',
    filtersOpened: '<',
    showDurationsAsDecimals: '<',
    totalsModeEnabled: '<',
    canDataColumnBeVisible: '<',
    schema: '<',
    type: '<',
    collapsedGroups: '=',
    toggleCollapse: '=',
    sortMethod: '=?orderBy',
    getDataForExport: '=?',
    statsOpened: '<',
  },
  templateUrl: payrollTableGroupedComponentUrl,
  controllerAs: 'ctrl',
  controllerProvider: async () =>
    (await import(/* webpackChunkName: "reports" */ './payrollTableGroupedComponentCtrl')).default,
};
